import React, {useContext, useEffect, useRef, useState} from 'react';
import {CopyOutlined, CheckOutlined, EditOutlined, DeleteOutlined, ReloadOutlined} from '@ant-design/icons';
import {
    Anchor,
    Breadcrumb,
    Button,
    Card, Cascader,
    Divider,
    Drawer,
    Flex,
    Form, FormInstance,
    Input,
    InputRef, Layout, Menu,
    message,
    Modal,
    Table,
    Tabs, Tag,
    Tooltip, FloatButton, Empty
} from "antd";
import {useLocation, useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import copy from "copy-to-clipboard";
import Sider from 'antd/es/layout/Sider';
import {Content} from 'antd/es/layout/layout';
import {MdRefresh} from "react-icons/md";
import {AiOutlineSwap} from "react-icons/ai";
import {FaCogs, FaPlus} from "react-icons/fa";
import TextArea from "antd/es/input/TextArea";


const Knowledge_detail = () => {


    document.title='知识库';

    const url_info_l = useLocation();


    const url_info_ldd = new URLSearchParams(url_info_l.search)


    const navigate = useNavigate();

    let data_time = dayjs().unix();

    useEffect(() => {


        window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部


        console.log(String(url_info_ldd.get('product_uuid')))
        if (String(url_info_ldd.get('product_uuid')) !== 'null') {

            setfetch_knowledge_detail_select_log({message: 'click', value: '', time: data_time})
            setfetch_knowledge_detail_select_info({
                value1: String(url_info_ldd.get('product_uuid')),
                value2: '',
                value3: '',
                time: data_time
            })
        }

        setfilter_spu_sort_uuid_select_log({message: '11', value: '', time: data_time})

        setfetch_sort_shop_select_log({message: '11', value: '', time: data_time})
    }, []);


    const [fetch_knowledge_detail_select_info, setfetch_knowledge_detail_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [fetch_knowledge_detail_select_log, setfetch_knowledge_detail_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const fetch_knowledge_detail = (e1: any) => {

        setfetch_knowledge_detail_select_log({message: 'click', value: '', time: data_time})


        setfetch_knowledge_detail_select_info({
            value1: String(url_info_ldd.get('product_uuid')),
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_fetch_knowledge_detail, setreturn_data_fetch_knowledge_detail] = useState({

        "message": 0,
        "value": "获取成功",
        "info": {
            "spu": {
                "id": "1",
                "uuid": "100001",
                "name": "Apple iPhone 13",
                "description": "最新款苹果手机，性能卓越，拍照效果出色",
                "category_id": "1",
                "brand_id": "1",
                "sort_shop_uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                "status": "1",
                "status_type": "在售",
                "buy_it_now": "600",
                "image_card_img": "https://myupdat.leytcn.com/upload/1726199774_Untitled-3.jpg",
                "region_id": "6666",
                "created": 0,
                "created_at": "2024-10-24 14:29:00",
                "updated_at": "2024-11-22 20:01:19",
                "country_code": "56888"
            },
            "detail": [
                {
                    "id": "1",
                    "uuid": "2a91cf9e-6ebb-4dac-804d-407e4d594ca1",
                    "userid": null,
                    "sort_name": "聊天互动",
                    "created": "1728695319",
                    "status": "en",
                    "updated": null,
                    "parent_uuid": "0",
                    "country_code": "56888",
                    "region_parent_id": null,
                    "region_id": "6666",
                    "row_num": "999",
                    "children": [
                        {
                            "id": "4",
                            "uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
                            "userid": null,
                            "sort_name": "问候类",
                            "created": "1729152105",
                            "status": "en",
                            "updated": null,
                            "parent_uuid": "2a91cf9e-6ebb-4dac-804d-407e4d594ca1",
                            "country_code": "56888",
                            "region_parent_id": null,
                            "region_id": null,
                            "row_num": "999",
                            "children": []
                        },
                        {
                            "id": "5",
                            "uuid": "9a8dcd62-dc4c-415c-8b11-a3efd4494ebd",
                            "userid": null,
                            "sort_name": "发送表",
                            "created": "1729152355",
                            "status": "en",
                            "updated": "1732254993",
                            "parent_uuid": "2a91cf9e-6ebb-4dac-804d-407e4d594ca1",
                            "country_code": "56888",
                            "region_parent_id": null,
                            "region_id": null,
                            "row_num": "999",
                            "children": []
                        }
                    ]
                },
                {
                    "id": "2",
                    "uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                    "userid": null,
                    "sort_name": "商品问题",
                    "created": null,
                    "status": "en",
                    "updated": null,
                    "parent_uuid": "0",
                    "country_code": "56888",
                    "region_parent_id": null,
                    "region_id": "6666",
                    "row_num": "999",
                    "children": []
                },
                {
                    "id": "3",
                    "uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                    "userid": null,
                    "sort_name": "活动优惠",
                    "created": null,
                    "status": "en",
                    "updated": null,
                    "parent_uuid": "0",
                    "country_code": "56888",
                    "region_parent_id": null,
                    "region_id": "6666",
                    "row_num": "999",
                    "children": []
                }
            ]
        }
    });


    const [firstItemKey_one, setfirstItemKey_one] = useState({value1: '', value2: '', value3: '', time: 0})
    const fetch_knowledge_detail_body = new FormData();


    fetch_knowledge_detail_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    fetch_knowledge_detail_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_knowledge_detail_body.append('time', String(fetch_knowledge_detail_select_info.time));

    fetch_knowledge_detail_body.append('action', 'fetch_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/fetch/fetch_knowledge_detail.php', {


                method: 'POST',
                body: fetch_knowledge_detail_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_knowledge_detail(return_data);

                    const firstItemKey_one = return_data.info.detail.length > 0 ? return_data.info.detail[0].uuid : 0;

                    /*  settabs_one_activeKey(firstItemKey_one)*/

                    if (tabs_one_activeKey === '') {


                        settabs_one_activeKey(firstItemKey_one)
                    }
                    setfetch_knowledge_knowledge_scene_select_log({message: 'ddd', value: '', time: data_time})
                /*    // setfirstItemKey_one({value1:firstItemKey_one,value2:'',value3:'',time:0})
                    const firstItemKey_two = return_data.info.detail.length > 0 && return_data.info.detail[0].children.length > 0
                        ? return_data.info.detail[0].children[0].uuid
                        : null;
                    settabs_two_activeKey(firstItemKey_two)

                    setfetch_knowledge_knowledge_scene_select_log({message: 'dd', value: '', time: data_time})*/

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (fetch_knowledge_detail_select_log.message !== '') {

            data_async();
            setfetch_knowledge_detail_select_log({message: '', value: '', time: 0})
        }
    }, [fetch_knowledge_detail_select_log]);

    const [tabs_one_activeKey, settabs_one_activeKey] = useState('')


    const [fetch_knowledge_knowledge_scene_select_info, setfetch_knowledge_knowledge_scene_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [fetch_knowledge_knowledge_scene_select_log, setfetch_knowledge_knowledge_scene_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const fetch_knowledge_knowledge_scene = (e1: any) => {

        setfetch_knowledge_knowledge_scene_select_log({message: 'click', value: '', time: data_time})


        setfetch_knowledge_knowledge_scene_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

    const [return_data_fetch_knowledge_knowledge_scene_tabs, setreturn_data_fetch_knowledge_knowledge_scene_tabs] = useState([])

    const [return_data_fetch_knowledge_knowledge_scene, setreturn_data_fetch_knowledge_knowledge_scene] = useState({
        "message": 2000,
        "value": "获取成功",
        "info": {
            "scene": [
                {
                    "id": "154",
                    "uuid": "666111",
                    "userid": null,
                    "title": null,
                    "created": null,
                    "status": "en",
                    "updated": null,
                    "parent_uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
                    "country_code": "56888",
                    "region_parent_id": null,
                    tab1_uuid: '',
                    tab1_info: {
                        "id": "34",
                        "uuid": "9aa69b7c-356f-4a6c-9b7c-813230fbcf36",
                        "userid": null,
                        "sort_name": "手机模式",
                        "created": null,
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "0",
                        "product_uuid": "100001"
                    },
                    tab2_uuid: '',
                    tab2_info: {
                        "id": "34",
                        "uuid": "9aa69b7c-356f-4a6c-9b7c-813230fbcf36",
                        "userid": null,
                        "sort_name": "手机模式",
                        "created": null,
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "0",
                        "product_uuid": "100001"
                    },
                    "region_id": null,
                    "row_num": null,
                    "scene_question": [
                        {
                            "id": "154",
                            "uuid": "666111",
                            "title": "你好",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "666111",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": "1"
                        }
                    ],
                    scene_solution: [
                        {
                            "id": "154",
                            "uuid": "666111",
                            "title": "你好",
                            "solution": null,
                            "finish_data_values": null,
                            "parent_uuid": "666111",
                            "parent_id": null,
                            "user_token": null,
                            "status": "en",
                            "country_code": "56888",
                            "created": null,
                            "deleted": null,
                            "updated": null,
                            "isshow": "1"
                        }
                    ]
                }
            ]
        }
    });
    const [tabs_two_activeKey, settabs_two_activeKey] = useState('')

    const fetch_knowledge_knowledge_scene_body = new FormData();


    fetch_knowledge_knowledge_scene_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    fetch_knowledge_knowledge_scene_body.append('uuid', tabs_one_activeKey);

    fetch_knowledge_knowledge_scene_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_knowledge_knowledge_scene_body.append('time', String(fetch_knowledge_knowledge_scene_select_info.time));

    fetch_knowledge_knowledge_scene_body.append('action', 'fetch_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/scene/fetch/fetch_scene_info.php', {


                method: 'POST',
                body: fetch_knowledge_knowledge_scene_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

//无需通知
                    // message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_knowledge_knowledge_scene(return_data);


                    //       setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (fetch_knowledge_knowledge_scene_select_log.message !== '') {

            data_async();
            setfetch_knowledge_knowledge_scene_select_log({message: '', value: '', time: 0})
        }
    }, [fetch_knowledge_knowledge_scene_select_log]);


    const onClick_tabs_v = (e1: any) => {


        console.log({uuid: e1})
        settabs_two_activeKey(e1)

        setfetch_knowledge_knowledge_scene_select_log({message: 'click', value: '', time: data_time})


        setfetch_knowledge_knowledge_scene_select_info({value1: e1, value2: '', value3: '', time: data_time})


    }


    const click_tabs_v_button_detail = (e1: any) => {


        console.log(e1)


    }



    const [add_knowledge_scene_modal_open, setadd_knowledge_scene_modal_open] = useState(false)

    const [add_knowledge_scene_select_info, setadd_knowledge_scene_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [add_knowledge_scene_select_log, setadd_knowledge_scene_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const add_knowledge_scene = (e1: any) => {

        setadd_knowledge_scene_select_log({message: 'click', value: '', time: data_time})

        setadd_knowledge_scene_modal_open(true);

        setadd_knowledge_scene_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setadd_knowledge_scene_modal_oncancel = () => {

        setadd_knowledge_scene_modal_open(false);
    }


    const [add_knowledge_scene_modal_form] = Form.useForm();

    const add_knowledge_scene_modal_initialValues = {}

    const [add_knowledge_scene_modal_onfinish_select_log, setadd_knowledge_scene_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [add_knowledge_scene_modal_onfinish_select_info, setadd_knowledge_scene_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const add_knowledge_scene_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setadd_knowledge_scene_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setadd_knowledge_scene_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_add_knowledge_scene, setreturn_data_add_knowledge_scene] = useState({});

    const add_knowledge_scene_body = new FormData();


    add_knowledge_scene_body.append('tab1_uuid', tabs_one_activeKey);

    add_knowledge_scene_body.append('tab2_uuid', tabs_two_activeKey);

    add_knowledge_scene_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    add_knowledge_scene_body.append('uuid', tabs_one_activeKey);

    add_knowledge_scene_body.append('finish_data', JSON.stringify(add_knowledge_scene_modal_onfinish_select_info.value1));

    add_knowledge_scene_body.append('userToken', String(Cookies.get('userToken_chattool')));

    add_knowledge_scene_body.append('time', String(add_knowledge_scene_modal_onfinish_select_info.time));

    add_knowledge_scene_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/scene/insert/insert_scene.php', {


                method: 'POST',
                body: add_knowledge_scene_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();
                    add_knowledge_scene_modal_form.setFieldValue('scene_title',undefined)


                    setadd_knowledge_scene_modal_open(false)

                    setreturn_data_add_knowledge_scene(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_knowledge_knowledge_scene_select_log({message: 'dd', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (add_knowledge_scene_modal_onfinish_select_log.message !== '') {

            data_async();
            setadd_knowledge_scene_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [add_knowledge_scene_modal_onfinish_select_log]);


    const [knowledge_detail_scene_question_add_modal_open, setknowledge_detail_scene_question_add_modal_open] = useState(false)

    const [knowledge_detail_scene_question_add_select_info, setknowledge_detail_scene_question_add_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_scene_question_add_select_log, setknowledge_detail_scene_question_add_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_scene_question_add = (e1: any) => {

        setknowledge_detail_scene_question_add_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_scene_question_add_modal_open(true);

        setknowledge_detail_scene_question_add_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_scene_question_add_modal_oncancel = () => {

        setknowledge_detail_scene_question_add_modal_open(false);
    }


    const [knowledge_detail_scene_question_add_modal_form] = Form.useForm();

    const knowledge_detail_scene_question_add_modal_initialValues = {}

    const [knowledge_detail_scene_question_add_modal_onfinish_select_log, setknowledge_detail_scene_question_add_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_scene_question_add_modal_onfinish_select_info, setknowledge_detail_scene_question_add_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_scene_question_add_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_scene_question_add_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setknowledge_detail_scene_question_add_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_detail_scene_question_add, setreturn_data_knowledge_detail_scene_question_add] = useState({});

    const knowledge_detail_scene_question_add_body = new FormData();


    knowledge_detail_scene_question_add_body.append('tabuuid', tabs_two_activeKey);

    knowledge_detail_scene_question_add_body.append('uuid', knowledge_detail_scene_question_add_select_info.value1);
    knowledge_detail_scene_question_add_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    knowledge_detail_scene_question_add_body.append('finish_data', JSON.stringify(knowledge_detail_scene_question_add_modal_onfinish_select_info.value1));

    knowledge_detail_scene_question_add_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_scene_question_add_body.append('time', String(knowledge_detail_scene_question_add_modal_onfinish_select_info.time));

    knowledge_detail_scene_question_add_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/question/insert/insert_question.php', {


                method: 'POST',
                body: knowledge_detail_scene_question_add_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    knowledge_detail_scene_question_add_modal_form.setFieldValue('question_title',undefined)

                    setknowledge_detail_scene_question_add_modal_open(false)

                    setreturn_data_knowledge_detail_scene_question_add(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    setfetch_knowledge_knowledge_scene_select_log({message: 'dd', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_scene_question_add_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_scene_question_add_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_scene_question_add_modal_onfinish_select_log]);


    const [knowledge_detail_solution_add_modal_open, setknowledge_detail_solution_add_modal_open] = useState(false)

    const [knowledge_detail_solution_add_select_info, setknowledge_detail_solution_add_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_solution_add_select_log, setknowledge_detail_solution_add_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_solution_add = (e1: any) => {

        setknowledge_detail_solution_add_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_solution_add_modal_open(true);

        setknowledge_detail_solution_add_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_solution_add_modal_oncancel = () => {

        setknowledge_detail_solution_add_modal_open(false);
    }


    const [knowledge_detail_solution_add_modal_form] = Form.useForm();

    const knowledge_detail_solution_add_modal_initialValues = {}

    const [knowledge_detail_solution_add_modal_onfinish_select_log, setknowledge_detail_solution_add_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_solution_add_modal_onfinish_select_info, setknowledge_detail_solution_add_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_solution_add_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_solution_add_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setknowledge_detail_solution_add_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_detail_solution_add, setreturn_data_knowledge_detail_solution_add] = useState({});

    const knowledge_detail_solution_add_body = new FormData();


    knowledge_detail_solution_add_body.append('finish_data', JSON.stringify(knowledge_detail_solution_add_modal_onfinish_select_info.value1));

    knowledge_detail_solution_add_body.append('userToken', String(Cookies.get('userToken_chattool')));


    knowledge_detail_solution_add_body.append('tab1_uuid', tabs_one_activeKey);

    knowledge_detail_solution_add_body.append('tab2_uuid', tabs_two_activeKey);

    knowledge_detail_solution_add_body.append('uuid', knowledge_detail_solution_add_select_info.value1);

    knowledge_detail_solution_add_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    knowledge_detail_solution_add_body.append('time', String(knowledge_detail_solution_add_modal_onfinish_select_info.time));

    knowledge_detail_solution_add_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/solution/insert/insert_solution.php', {


                method: 'POST',
                body: knowledge_detail_solution_add_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    knowledge_detail_solution_add_modal_form.setFieldValue('solution_message',undefined)
                    setknowledge_detail_solution_add_modal_open(false)

                    setreturn_data_knowledge_detail_solution_add(return_data);
                    setfetch_knowledge_knowledge_scene_select_log({message: 'dd', value: '', time: data_time})


                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_solution_add_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_solution_add_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_solution_add_modal_onfinish_select_log]);


    const [search_knowledge_detail_modal_open, setsearch_knowledge_detail_modal_open] = useState(false)

    const [search_knowledge_detail_select_info, setsearch_knowledge_detail_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [search_knowledge_detail_select_log, setsearch_knowledge_detail_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const search_knowledge_detail = (e1: any) => {

        setsearch_knowledge_detail_select_log({message: 'click', value: '', time: data_time})

        setsearch_knowledge_detail_modal_open(true);

        setsearch_knowledge_detail_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setsearch_knowledge_detail_modal_oncancel = () => {

        setsearch_knowledge_detail_modal_open(false);
    }


    const [search_knowledge_detail_modal_form] = Form.useForm();

    const search_knowledge_detail_modal_initialValues = {}

    const [search_knowledge_detail_modal_onfinish_select_log, setsearch_knowledge_detail_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [search_knowledge_detail_modal_onfinish_select_info, setsearch_knowledge_detail_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const search_knowledge_detail_modal_onfinish = (e1: any) => {

        console.log({dd: e1})

        if (e1.scene_scene_question === undefined && e1.scene_scene_solution === undefined && e1.scene_search === undefined) {
            message.error('请输入搜索内容')
            return
        } else {


            setfilter_table('1')
            setsearch_knowledge_detail_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
            setsearch_knowledge_detail_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})

        }


    }


    const [return_data_search_knowledge_detail, setreturn_data_search_knowledge_detail] = useState({});

    const search_knowledge_detail_body = new FormData();


    search_knowledge_detail_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    search_knowledge_detail_body.append('finish_data', JSON.stringify(search_knowledge_detail_modal_onfinish_select_info.value1));

    search_knowledge_detail_body.append('userToken', String(Cookies.get('userToken_chattool')));

    search_knowledge_detail_body.append('time', String(search_knowledge_detail_modal_onfinish_select_info.time));

    search_knowledge_detail_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/search/fetch/search_fetch.php', {


                method: 'POST',
                body: search_knowledge_detail_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setsearch_knowledge_detail_modal_open(false)

                    setreturn_data_search_knowledge_detail(return_data);

                    setreturn_data_fetch_knowledge_knowledge_scene(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (search_knowledge_detail_modal_onfinish_select_log.message !== '') {

            data_async();
            setsearch_knowledge_detail_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [search_knowledge_detail_modal_onfinish_select_log]);


    const cancal_filter_button = () => {

        setfilter_table('0')
        search_knowledge_detail_modal_form.resetFields();

        //    setfetch_knowledge_detail_select_log({message: 'click', value: '', time: data_time})
        setfetch_knowledge_knowledge_scene_select_log({message: 'dd', value: '', time: data_time})


    }


    const [knowledge_detail_tabs_one_modal_open, setknowledge_detail_tabs_one_modal_open] = useState(false)

    const [knowledge_detail_tabs_one_select_info, setknowledge_detail_tabs_one_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_tabs_one_select_log, setknowledge_detail_tabs_one_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_tabs_one = (e1: any) => {

        setknowledge_detail_tabs_one_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_tabs_one_modal_open(true);

        setknowledge_detail_tabs_one_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_tabs_one_modal_oncancel = () => {

        setknowledge_detail_tabs_one_modal_open(false);
    }


    const [knowledge_detail_tabs_one_modal_form] = Form.useForm();

    const knowledge_detail_tabs_one_modal_initialValues = {}

    const [knowledge_detail_tabs_one_modal_onfinish_select_log, setknowledge_detail_tabs_one_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_tabs_one_modal_onfinish_select_info, setknowledge_detail_tabs_one_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_tabs_one_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_tabs_one_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setknowledge_detail_tabs_one_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_knowledge_detail_tabs_one, setreturn_data_knowledge_detail_tabs_one] = useState({});

    const knowledge_detail_tabs_one_body = new FormData();

    knowledge_detail_tabs_one_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_tabs_one_body.append('finish_data', JSON.stringify(knowledge_detail_tabs_one_modal_onfinish_select_info.value1));

    knowledge_detail_tabs_one_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_tabs_one_body.append('time', String(knowledge_detail_tabs_one_modal_onfinish_select_info.time));

    knowledge_detail_tabs_one_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/insert/insert_tabname_one.php', {


                method: 'POST',
                body: knowledge_detail_tabs_one_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_tabs_one_modal_open(false)

                    setreturn_data_knowledge_detail_tabs_one(return_data);
                    setfetch_knowledge_detail_select_log({message: 'dd', value: '', time: data_time})
                    setfetch_knowledge_detail_tabs_one_info_select_log({message: '1', value: '', time: data_time})


                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_tabs_one_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_tabs_one_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_tabs_one_modal_onfinish_select_log]);

    const [onClick_tabs_one_switch_info, setonClick_tabs_one_switch_info] = useState({
        uuid: '',
        value2: '',
        value3: '',
        time: 0
    })

    const onClick_tabs_one_switch = (uuid: any) => {


        setActiveKey(uuid);
        settabs_one_activeKey(uuid)
        console.log({one_tab: uuid})

        setonClick_tabs_one_switch_info({uuid: uuid, value2: '', value3: '', time: data_time})


        // let firstItemKey_two =  return_data_fetch_knowledge_detail.info.detail.find(item1_filter=>item1_filter.uuid===uuid).children.map(item1_children=>(item1_children.children.map(item2=>(item2.uuid))));

        let firstItemKey_two = return_data_fetch_knowledge_detail.info.detail.find(item1 => item1.uuid === uuid)?.children?.[0]?.uuid || null;


        console.log(firstItemKey_two);
        settabs_two_activeKey(String(firstItemKey_two))
        setfetch_knowledge_knowledge_scene_select_log({message: '21', value: '', time: data_time})


    }


    const [knowledge_detail_tabs_two_modal_open, setknowledge_detail_tabs_two_modal_open] = useState(false)

    const [knowledge_detail_tabs_two_select_info, setknowledge_detail_tabs_two_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_tabs_two_select_log, setknowledge_detail_tabs_two_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_tabs_two = (e1: any) => {

        setknowledge_detail_tabs_two_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_tabs_two_modal_open(true);

        setknowledge_detail_tabs_two_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_tabs_two_modal_oncancel = () => {

        setknowledge_detail_tabs_two_modal_open(false);
    }


    const [knowledge_detail_tabs_two_modal_form] = Form.useForm();

    const knowledge_detail_tabs_two_modal_initialValues = {}

    const [knowledge_detail_tabs_two_modal_onfinish_select_log, setknowledge_detail_tabs_two_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_tabs_two_modal_onfinish_select_info, setknowledge_detail_tabs_two_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_tabs_two_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_tabs_two_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setknowledge_detail_tabs_two_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_knowledge_detail_tabs_two, setreturn_data_knowledge_detail_tabs_two] = useState({});

    const knowledge_detail_tabs_two_body = new FormData();


    // knowledge_detail_tabs_two_body.append('tab_one_uuid', onClick_tabs_one_switch_info.uuid);
    knowledge_detail_tabs_two_body.append('tab_one_uuid', tabs_one_activeKey);


    knowledge_detail_tabs_two_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_tabs_two_body.append('finish_data', JSON.stringify(knowledge_detail_tabs_two_modal_onfinish_select_info.value1));

    knowledge_detail_tabs_two_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_tabs_two_body.append('time', String(knowledge_detail_tabs_two_modal_onfinish_select_info.time));

    knowledge_detail_tabs_two_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/insert/insert_tabname_two.php', {


                method: 'POST',
                body: knowledge_detail_tabs_two_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_tabs_two_modal_open(false)

                    setreturn_data_knowledge_detail_tabs_two(return_data);

                    setfetch_knowledge_detail_select_log({message: 'ddd', value: '', time: data_time})

                    setfetch_knowledge_detail_tabs_two_info_select_log({message: '1', value: '', time: data_time})

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_tabs_two_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_tabs_two_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_tabs_two_modal_onfinish_select_log]);


    const [activeKey, setActiveKey] = useState('1');
    const activeKey_tab_one = (e1: any) => {


        console.log('ddd' + e1)
    }


    const [fetch_knowledge_detail_tabs_one_info_modal_open, setfetch_knowledge_detail_tabs_one_info_modal_open] = useState(false)

    const [fetch_knowledge_detail_tabs_one_info_select_info, setfetch_knowledge_detail_tabs_one_info_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [fetch_knowledge_detail_tabs_one_info_select_log, setfetch_knowledge_detail_tabs_one_info_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const fetch_knowledge_detail_tabs_one_info = (e1: any) => {

        setfetch_knowledge_detail_tabs_one_info_select_log({message: 'click', value: '', time: data_time})

        setfetch_knowledge_detail_tabs_one_info_modal_open(true);

        setfetch_knowledge_detail_tabs_one_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setfetch_knowledge_detail_tabs_one_info_modal_oncancel = () => {

        setfetch_knowledge_detail_tabs_one_info_modal_open(false);
    }


    const [fetch_knowledge_detail_tabs_one_info_modal_form] = Form.useForm();

    const fetch_knowledge_detail_tabs_one_info_modal_initialValues = {}

    const [fetch_knowledge_detail_tabs_one_info_modal_onfinish_select_log, setfetch_knowledge_detail_tabs_one_info_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [fetch_knowledge_detail_tabs_one_info_modal_onfinish_select_info, setfetch_knowledge_detail_tabs_one_info_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const fetch_knowledge_detail_tabs_one_info_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setfetch_knowledge_detail_tabs_one_info_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setfetch_knowledge_detail_tabs_one_info_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_fetch_knowledge_detail_tabs_one_info, setreturn_data_fetch_knowledge_detail_tabs_one_info] = useState({
        "message": 2000,
        "value": "获取成功",
        "info": [
            {
                "id": "1",
                "uuid": "2a91cf9e-6ebb-4dac-804d-407e4d594ca1",
                "userid": null,
                "sort_name": "聊天互动",
                "created": 0,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "product_uuid": "100001",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999"
            },

        ]
    });

    const fetch_knowledge_detail_tabs_one_info_body = new FormData();

    fetch_knowledge_detail_tabs_one_info_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    fetch_knowledge_detail_tabs_one_info_body.append('finish_data', JSON.stringify(fetch_knowledge_detail_tabs_one_info_modal_onfinish_select_info.value1));

    fetch_knowledge_detail_tabs_one_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_knowledge_detail_tabs_one_info_body.append('time', String(fetch_knowledge_detail_tabs_one_info_modal_onfinish_select_info.time));

    fetch_knowledge_detail_tabs_one_info_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/fetch/fetch_tabname_one.php', {


                method: 'POST',
                body: fetch_knowledge_detail_tabs_one_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*   message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    //    setfetch_knowledge_detail_tabs_one_info_modal_open(false)

                    setreturn_data_fetch_knowledge_detail_tabs_one_info(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (fetch_knowledge_detail_tabs_one_info_select_log.message !== '') {

            data_async();
            setfetch_knowledge_detail_tabs_one_info_select_log({message: '', value: '', time: 0})
        }
    }, [fetch_knowledge_detail_tabs_one_info_select_log]);


    const [fetch_knowledge_detail_tabs_two_info_modal_open, setfetch_knowledge_detail_tabs_two_info_modal_open] = useState(false)

    const [fetch_knowledge_detail_tabs_two_info_select_info, setfetch_knowledge_detail_tabs_two_info_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [fetch_knowledge_detail_tabs_two_info_select_log, setfetch_knowledge_detail_tabs_two_info_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const fetch_knowledge_detail_tabs_two_info = (e1: any) => {

        setfetch_knowledge_detail_tabs_two_info_select_log({message: 'click', value: '', time: data_time})

        setfetch_knowledge_detail_tabs_two_info_modal_open(true);

        setfetch_knowledge_detail_tabs_two_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setfetch_knowledge_detail_tabs_two_info_modal_oncancel = () => {

        setfetch_knowledge_detail_tabs_two_info_modal_open(false);
    }


    const [fetch_knowledge_detail_tabs_two_info_modal_form] = Form.useForm();

    const fetch_knowledge_detail_tabs_two_info_modal_initialValues = {}

    const [fetch_knowledge_detail_tabs_two_info_modal_onfinish_select_log, setfetch_knowledge_detail_tabs_two_info_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [fetch_knowledge_detail_tabs_two_info_modal_onfinish_select_info, setfetch_knowledge_detail_tabs_two_info_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const fetch_knowledge_detail_tabs_two_info_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setfetch_knowledge_detail_tabs_two_info_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setfetch_knowledge_detail_tabs_two_info_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_fetch_knowledge_detail_tabs_two_info, setreturn_data_fetch_knowledge_detail_tabs_two_info] = useState({
        "message": 2000,
        "value": "获取成功",
        "info": [
            {
                "id": "4",
                "uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
                "userid": null,
                "sort_name": "问候类",
                "created": "1729152105",
                "status": "en",
                "updated": null,
                "parent_uuid": "2a91cf9e-6ebb-4dac-804d-407e4d594ca1",
                "product_uuid": "100001",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": null,
                "row_num": "999"
            },

        ]
    });

    const fetch_knowledge_detail_tabs_two_info_body = new FormData();

    fetch_knowledge_detail_tabs_two_info_body.append('tab1_uuid', tabs_one_activeKey);


    fetch_knowledge_detail_tabs_two_info_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    fetch_knowledge_detail_tabs_two_info_body.append('finish_data', JSON.stringify(fetch_knowledge_detail_tabs_two_info_modal_onfinish_select_info.value1));

    fetch_knowledge_detail_tabs_two_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_knowledge_detail_tabs_two_info_body.append('time', String(fetch_knowledge_detail_tabs_two_info_modal_onfinish_select_info.time));

    fetch_knowledge_detail_tabs_two_info_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/fetch/fetch_tabname_two.php', {


                method: 'POST',
                body: fetch_knowledge_detail_tabs_two_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*      message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    //   setfetch_knowledge_detail_tabs_two_info_modal_open(false)

                    setreturn_data_fetch_knowledge_detail_tabs_two_info(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (fetch_knowledge_detail_tabs_two_info_select_log.message !== '') {

            data_async();
            setfetch_knowledge_detail_tabs_two_info_select_log({message: '', value: '', time: 0})
        }
    }, [fetch_knowledge_detail_tabs_two_info_select_log]);


    const [tabs_one_rename_modal_open, settabs_one_rename_modal_open] = useState(false)

    const [tabs_one_rename_select_info, settabs_one_rename_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [tabs_one_rename_select_log, settabs_one_rename_select_log] = useState({message: '', value: '', time: 0})
    const tabs_one_rename = (e1: any,e2:any) => {




        tabs_one_rename_modal_form.setFieldValue('tabs_one_rename',e2)
        settabs_one_rename_select_log({message: 'click', value: '', time: data_time})

        settabs_one_rename_modal_open(true);

        settabs_one_rename_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const settabs_one_rename_modal_oncancel = () => {

        settabs_one_rename_modal_open(false);
    }


    const [tabs_one_rename_modal_form] = Form.useForm();

    const tabs_one_rename_modal_initialValues = {}

    const [tabs_one_rename_modal_onfinish_select_log, settabs_one_rename_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [tabs_one_rename_modal_onfinish_select_info, settabs_one_rename_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const tabs_one_rename_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        settabs_one_rename_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        settabs_one_rename_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_tabs_one_rename, setreturn_data_tabs_one_rename] = useState({});

    const tabs_one_rename_body = new FormData();

    tabs_one_rename_body.append('tab_uuid', tabs_one_rename_select_info.value1);

    tabs_one_rename_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    tabs_one_rename_body.append('finish_data', JSON.stringify(tabs_one_rename_modal_onfinish_select_info.value1));

    tabs_one_rename_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tabs_one_rename_body.append('time', String(tabs_one_rename_modal_onfinish_select_info.time));

    tabs_one_rename_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/rename/rename_tabname_one.php', {


                method: 'POST',
                body: tabs_one_rename_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    settabs_one_rename_modal_open(false)

                    setreturn_data_tabs_one_rename(return_data);

                    setfetch_knowledge_detail_tabs_one_info_select_log({message: 'dd', value: '', time: data_time})
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_knowledge_detail_select_log({message: 'd', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (tabs_one_rename_modal_onfinish_select_log.message !== '') {

            data_async();
            settabs_one_rename_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [tabs_one_rename_modal_onfinish_select_log]);


    const [tabs_two_del_modal_open, settabs_two_del_modal_open] = useState(false)

    const [tabs_two_del_select_info, settabs_two_del_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [tabs_two_del_select_log, settabs_two_del_select_log] = useState({message: '', value: '', time: 0})
    const tabs_two_del = (e1: any) => {

        settabs_two_del_select_log({message: 'click', value: '', time: data_time})

        settabs_two_del_modal_open(true);

        settabs_two_del_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const settabs_two_del_modal_oncancel = () => {

        settabs_two_del_modal_open(false);
    }


    const [tabs_two_del_modal_next_button_select_log, settabs_two_del_modal_next_button_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const tabs_two_del_modal_next_button = () => {

        let data_time = dayjs().unix();

        settabs_two_del_modal_next_button_select_log({message: 'next_button', value: '', time: data_time})

    }


    const [return_data_tabs_two_del, setreturn_data_tabs_two_del] = useState({});

    const tabs_two_del_body = new FormData();


    tabs_two_del_body.append('tab1_uuid', tabs_two_del_select_info.value1);

    tabs_two_del_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    tabs_two_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tabs_two_del_body.append('time', String(tabs_two_del_modal_next_button_select_log.time));

    tabs_two_del_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/delete/delete_tabname_two.php', {


                method: 'POST',
                body: tabs_two_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    settabs_two_del_modal_open(false)

                    setreturn_data_tabs_two_del(return_data);

                    setfetch_knowledge_detail_tabs_two_info_select_log({message: 'zz', value: '', time: data_time})

                    setfetch_knowledge_detail_select_log({message: 'd', value: '', time: data_time})
                    //    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

            }

        }


        if (tabs_two_del_modal_next_button_select_log.message !== '') {

            data_async();
            settabs_two_del_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [tabs_two_del_modal_next_button_select_log]);


    const [tabs_one_del_modal_open, settabs_one_del_modal_open] = useState(false)

    const [tabs_one_del_select_info, settabs_one_del_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [tabs_one_del_select_log, settabs_one_del_select_log] = useState({message: '', value: '', time: 0})
    const tabs_one_del = (e1: any) => {

        settabs_one_del_select_log({message: 'click', value: '', time: data_time})

        settabs_one_del_modal_open(true);

        settabs_one_del_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const settabs_one_del_modal_oncancel = () => {

        settabs_one_del_modal_open(false);
    }


    const [tabs_one_del_modal_next_button_select_log, settabs_one_del_modal_next_button_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const tabs_one_del_modal_next_button = () => {

        let data_time = dayjs().unix();

        settabs_one_del_modal_next_button_select_log({message: 'next_button', value: '', time: data_time})

    }


    const [return_data_tabs_one_del, setreturn_data_tabs_one_del] = useState({});

    const tabs_one_del_body = new FormData();

    tabs_one_del_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    tabs_one_del_body.append('tab1_uuid', tabs_one_del_select_info.value1);

    tabs_one_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tabs_one_del_body.append('time', String(tabs_one_del_modal_next_button_select_log.time));

    tabs_one_del_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/delete/delete_tabname_one.php', {


                method: 'POST',
                body: tabs_one_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    settabs_one_del_modal_open(false)

                    setreturn_data_tabs_one_del(return_data);

                    setfetch_knowledge_detail_tabs_one_info_select_log({message: 'd', value: '', time: data_time})

                    setfetch_knowledge_detail_select_log({message: 'd', value: '', time: data_time})
                    //  setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

            }

        }


        if (tabs_one_del_modal_next_button_select_log.message !== '') {

            data_async();
            settabs_one_del_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [tabs_one_del_modal_next_button_select_log]);


    const [tabs_two_rename_modal_open, settabs_two_rename_modal_open] = useState(false)

    const [tabs_two_rename_select_info, settabs_two_rename_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [tabs_two_rename_select_log, settabs_two_rename_select_log] = useState({message: '', value: '', time: 0})
    const tabs_two_rename = (e1: any) => {

        settabs_two_rename_select_log({message: 'click', value: '', time: data_time})

        settabs_two_rename_modal_open(true);

        settabs_two_rename_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const settabs_two_rename_modal_oncancel = () => {

        settabs_two_rename_modal_open(false);
    }


    const [tabs_two_rename_modal_form] = Form.useForm();

    const tabs_two_rename_modal_initialValues = {}

    const [tabs_two_rename_modal_onfinish_select_log, settabs_two_rename_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [tabs_two_rename_modal_onfinish_select_info, settabs_two_rename_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const tabs_two_rename_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        settabs_two_rename_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        settabs_two_rename_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_tabs_two_rename, setreturn_data_tabs_two_rename] = useState({});

    const tabs_two_rename_body = new FormData();


    tabs_two_rename_body.append('tab1_uuid', tabs_one_activeKey);


    tabs_two_rename_body.append('tab_uuid', tabs_two_rename_select_info.value1);

    tabs_two_rename_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    tabs_two_rename_body.append('finish_data', JSON.stringify(tabs_two_rename_modal_onfinish_select_info.value1));

    tabs_two_rename_body.append('userToken', String(Cookies.get('userToken_chattool')));

    tabs_two_rename_body.append('time', String(tabs_two_rename_modal_onfinish_select_info.time));

    tabs_two_rename_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/tabsswit/rename/rename_tabname_two.php', {


                method: 'POST',
                body: tabs_two_rename_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    settabs_two_rename_modal_open(false)

                    setreturn_data_tabs_two_rename(return_data);

                    setfetch_knowledge_detail_tabs_two_info_select_log({message: 'dd', value: '', time: data_time})

                    setfetch_knowledge_detail_select_log({message: 'd', value: '', time: data_time})
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (tabs_two_rename_modal_onfinish_select_log.message !== '') {

            data_async();
            settabs_two_rename_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [tabs_two_rename_modal_onfinish_select_log]);


    const [knowledge_detail_scene_edit_name_modal_open, setknowledge_detail_scene_edit_name_modal_open] = useState(false)

    const [knowledge_detail_scene_edit_name_select_info, setknowledge_detail_scene_edit_name_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_scene_edit_name_select_log, setknowledge_detail_scene_edit_name_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_scene_edit_name = (e1: any,e2:any) => {


        knowledge_detail_scene_edit_name_modal_form.setFieldValue('scene_name',e2)
        setknowledge_detail_scene_edit_name_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_scene_edit_name_modal_open(true);

        setknowledge_detail_scene_edit_name_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_scene_edit_name_modal_oncancel = () => {

        setknowledge_detail_scene_edit_name_modal_open(false);
    }


    const [knowledge_detail_scene_edit_name_modal_form] = Form.useForm();

    const knowledge_detail_scene_edit_name_modal_initialValues = {}

    const [knowledge_detail_scene_edit_name_modal_onfinish_select_log, setknowledge_detail_scene_edit_name_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_scene_edit_name_modal_onfinish_select_info, setknowledge_detail_scene_edit_name_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_scene_edit_name_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_scene_edit_name_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setknowledge_detail_scene_edit_name_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_detail_scene_edit_name, setreturn_data_knowledge_detail_scene_edit_name] = useState({});

    const knowledge_detail_scene_edit_name_body = new FormData();


    knowledge_detail_scene_edit_name_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_scene_edit_name_body.append('scene_uuid', knowledge_detail_scene_edit_name_select_info.value1);

    knowledge_detail_scene_edit_name_body.append('finish_data', JSON.stringify(knowledge_detail_scene_edit_name_modal_onfinish_select_info.value1));

    knowledge_detail_scene_edit_name_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_scene_edit_name_body.append('time', String(knowledge_detail_scene_edit_name_modal_onfinish_select_info.time));

    knowledge_detail_scene_edit_name_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/scene/update/scene_edit_name.php', {


                method: 'POST',
                body: knowledge_detail_scene_edit_name_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_scene_edit_name_modal_open(false)

                    setreturn_data_knowledge_detail_scene_edit_name(return_data);


                    setfetch_knowledge_knowledge_scene_select_log({message: 'd', value: '', time: data_time})

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_scene_edit_name_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_scene_edit_name_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_scene_edit_name_modal_onfinish_select_log]);


    const [knowledge_detail_scene_del_item_modal_open, setknowledge_detail_scene_del_item_modal_open] = useState(false)

    const [knowledge_detail_scene_del_item_select_info, setknowledge_detail_scene_del_item_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_scene_del_item_select_log, setknowledge_detail_scene_del_item_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_scene_del_item = (e1: any) => {

        setknowledge_detail_scene_del_item_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_scene_del_item_modal_open(true);

        setknowledge_detail_scene_del_item_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_scene_del_item_modal_oncancel = () => {

        setknowledge_detail_scene_del_item_modal_open(false);
    }


    const [knowledge_detail_scene_del_item_modal_next_button_select_log, setknowledge_detail_scene_del_item_modal_next_button_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const knowledge_detail_scene_del_item_modal_next_button = () => {

        let data_time = dayjs().unix();

        setknowledge_detail_scene_del_item_modal_next_button_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })

    }


    const [return_data_knowledge_detail_scene_del_item, setreturn_data_knowledge_detail_scene_del_item] = useState({});

    const knowledge_detail_scene_del_item_body = new FormData();


    knowledge_detail_scene_del_item_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_scene_del_item_body.append('scene_uuid', knowledge_detail_scene_del_item_select_info.value1);

    knowledge_detail_scene_del_item_body.append('id', knowledge_detail_scene_del_item_select_info.value1);

    knowledge_detail_scene_del_item_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_scene_del_item_body.append('time', String(knowledge_detail_scene_del_item_modal_next_button_select_log.time));

    knowledge_detail_scene_del_item_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/scene/delete/delete_scene_item.php', {


                method: 'POST',
                body: knowledge_detail_scene_del_item_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_scene_del_item_modal_open(false)

                    setreturn_data_knowledge_detail_scene_del_item(return_data);
                    setfetch_knowledge_knowledge_scene_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

            }

        }


        if (knowledge_detail_scene_del_item_modal_next_button_select_log.message !== '') {

            data_async();
            setknowledge_detail_scene_del_item_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_scene_del_item_modal_next_button_select_log]);


    const onEdit_one_tab = (e1: any) => {


        console.log(e1)
    }


    const handleAddEditClick = () => {


        console.log('ddd')
    }
    const EditableContext = React.createContext<FormInstance<any> | null>(null);


    const [editing, setEditing] = useState(false);
    const inputRef = useRef<InputRef>(null);
    const form = useContext(EditableContext)!;

    useEffect(() => {
        if (editing) {
            inputRef.current?.focus();
        }
    }, [editing]);

    const toggleEdit = () => {

    };


    const save = async () => {
        try {
            const values = await form.validateFields();

            toggleEdit();

        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    const copy_clipbord = (message_v: any) => {

        message.success('复制成功');
        copy(message_v)
    }


    const [knowledge_detail_scene_solution_edit_modal_open, setknowledge_detail_scene_solution_edit_modal_open] = useState(false)

    const [knowledge_detail_scene_solution_edit_select_info, setknowledge_detail_scene_solution_edit_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_scene_solution_edit_select_log, setknowledge_detail_scene_solution_edit_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_scene_solution_edit = (e1: any,e2:any) => {



        knowledge_detail_scene_solution_edit_modal_form.setFieldValue('scene_solution_name',e2)
        setknowledge_detail_scene_solution_edit_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_scene_solution_edit_modal_open(true);

        setknowledge_detail_scene_solution_edit_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_scene_solution_edit_modal_oncancel = () => {

        setknowledge_detail_scene_solution_edit_modal_open(false);
    }


    const [knowledge_detail_scene_solution_edit_modal_form] = Form.useForm();

    const knowledge_detail_scene_solution_edit_modal_initialValues = {}

    const [knowledge_detail_scene_solution_edit_modal_onfinish_select_log, setknowledge_detail_scene_solution_edit_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_scene_solution_edit_modal_onfinish_select_info, setknowledge_detail_scene_solution_edit_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_scene_solution_edit_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_scene_solution_edit_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setknowledge_detail_scene_solution_edit_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_detail_scene_solution_edit, setreturn_data_knowledge_detail_scene_solution_edit] = useState({});

    const knowledge_detail_scene_solution_edit_body = new FormData();

    knowledge_detail_scene_solution_edit_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_scene_solution_edit_body.append('solution_uuid', knowledge_detail_scene_solution_edit_select_info.value1);

    knowledge_detail_scene_solution_edit_body.append('finish_data', JSON.stringify(knowledge_detail_scene_solution_edit_modal_onfinish_select_info.value1));

    knowledge_detail_scene_solution_edit_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_scene_solution_edit_body.append('time', String(knowledge_detail_scene_solution_edit_modal_onfinish_select_info.time));

    knowledge_detail_scene_solution_edit_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/solution/edit/edit_solution.php', {


                method: 'POST',
                body: knowledge_detail_scene_solution_edit_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_scene_solution_edit_modal_open(false)

                    setreturn_data_knowledge_detail_scene_solution_edit(return_data);

                    setfetch_knowledge_knowledge_scene_select_log({message: 'd', value: '', time: data_time})

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_scene_solution_edit_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_scene_solution_edit_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_scene_solution_edit_modal_onfinish_select_log]);


    const [knowledge_detail_scene_solution_del_modal_open, setknowledge_detail_scene_solution_del_modal_open] = useState(false)

    const [knowledge_detail_scene_solution_del_select_info, setknowledge_detail_scene_solution_del_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_scene_solution_del_select_log, setknowledge_detail_scene_solution_del_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_scene_solution_del = (e1: any) => {

        setknowledge_detail_scene_solution_del_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_scene_solution_del_modal_open(true);

        setknowledge_detail_scene_solution_del_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_scene_solution_del_modal_oncancel = () => {

        setknowledge_detail_scene_solution_del_modal_open(false);
    }


    const [knowledge_detail_scene_solution_del_modal_next_button_select_log, setknowledge_detail_scene_solution_del_modal_next_button_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const knowledge_detail_scene_solution_del_modal_next_button = () => {

        let data_time = dayjs().unix();

        setknowledge_detail_scene_solution_del_modal_next_button_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })

    }


    const [return_data_knowledge_detail_scene_solution_del, setreturn_data_knowledge_detail_scene_solution_del] = useState({});

    const knowledge_detail_scene_solution_del_body = new FormData();


    knowledge_detail_scene_solution_del_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_scene_solution_del_body.append('solution_uuid', knowledge_detail_scene_solution_del_select_info.value1);

    knowledge_detail_scene_solution_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_scene_solution_del_body.append('time', String(knowledge_detail_scene_solution_del_modal_next_button_select_log.time));

    knowledge_detail_scene_solution_del_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/solution/delete/delete_solution.php', {


                method: 'POST',
                body: knowledge_detail_scene_solution_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*             message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_scene_solution_del_modal_open(false)

                    setreturn_data_knowledge_detail_scene_solution_del(return_data);
                    setfetch_knowledge_knowledge_scene_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

            }

        }


        if (knowledge_detail_scene_solution_del_modal_next_button_select_log.message !== '') {

            data_async();
            setknowledge_detail_scene_solution_del_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_scene_solution_del_modal_next_button_select_log]);

    const [filter_table, setfilter_table] = useState('0')


    const [knowledge_search_product_uuid_modal_open, setknowledge_search_product_uuid_modal_open] = useState(false)

    const [knowledge_search_product_uuid_select_info, setknowledge_search_product_uuid_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_search_product_uuid_select_log, setknowledge_search_product_uuid_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_search_product_uuid = (e1: any) => {

        setknowledge_search_product_uuid_select_log({message: 'click', value: '', time: data_time})

        setknowledge_search_product_uuid_modal_open(true);

        setknowledge_search_product_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_search_product_uuid_modal_oncancel = () => {

        setknowledge_search_product_uuid_modal_open(false);
    }


    const [knowledge_search_product_uuid_modal_form] = Form.useForm();

    const knowledge_search_product_uuid_modal_initialValues = {}

    const [knowledge_search_product_uuid_modal_onfinish_select_log, setknowledge_search_product_uuid_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_search_product_uuid_modal_onfinish_select_info, setknowledge_search_product_uuid_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_search_product_uuid_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();


        setknowledge_search_product_uuid_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setknowledge_search_product_uuid_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_search_product_uuid, setreturn_data_knowledge_search_product_uuid] = useState({});

    const knowledge_search_product_uuid_body = new FormData();


    knowledge_search_product_uuid_body.append('finish_data', JSON.stringify(knowledge_search_product_uuid_modal_onfinish_select_info.value1));

    knowledge_search_product_uuid_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_search_product_uuid_body.append('time', String(knowledge_search_product_uuid_modal_onfinish_select_info.time));

    knowledge_search_product_uuid_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/spu/isspu_check/isspu_check.php', {


                method: 'POST',
                body: knowledge_search_product_uuid_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setknowledge_search_product_uuid_modal_open(false)

                    setreturn_data_knowledge_search_product_uuid(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_knowledge_detail_select_log({message: '1', value: '', time: data_time})


                    const product_uuid_form = knowledge_search_product_uuid_modal_form.getFieldValue('product_uuid')
                    //     setproduct_uuid_d(product_uuid_form)

                    navigate('/admin/detail?product_uuid=' + product_uuid_form)


                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_search_product_uuid_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_search_product_uuid_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_search_product_uuid_modal_onfinish_select_log]);


    const [knowledge_detail_change_product_d_modal_open, setknowledge_detail_change_product_d_modal_open] = useState(false)

    const [knowledge_detail_change_product_d_select_info, setknowledge_detail_change_product_d_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_change_product_d_select_log, setknowledge_detail_change_product_d_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_change_product_d = (e1: any) => {


        setknowledge_detail_change_product_d_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_change_product_d_modal_open(true);

        setknowledge_detail_change_product_d_select_info({value1: e1, value2: '', value3: '', time: data_time})
        setfetch_sort_shop_select_log({message: 'dd', value: '', time: data_time})
        setfilter_spu_sort_uuid_select_log({message: 'd', value: '', time: data_time})


    }


    const setknowledge_detail_change_product_d_modal_oncancel = () => {

        setknowledge_detail_change_product_d_modal_open(false);
    }


    const [knowledge_detail_change_product_d_modal_form] = Form.useForm();

    const knowledge_detail_change_product_d_modal_initialValues = {}

    const [knowledge_detail_change_product_d_modal_onfinish_select_log, setknowledge_detail_change_product_d_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_change_product_d_modal_onfinish_select_info, setknowledge_detail_change_product_d_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_change_product_d_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_change_product_d_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setknowledge_detail_change_product_d_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_detail_change_product_d, setreturn_data_knowledge_detail_change_product_d] = useState({});

    const knowledge_detail_change_product_d_body = new FormData();


    knowledge_detail_change_product_d_body.append('finish_data', JSON.stringify(knowledge_detail_change_product_d_modal_onfinish_select_info.value1));

    knowledge_detail_change_product_d_body.append('userToken', String(Cookies.get('userToken_keyactive')));

    knowledge_detail_change_product_d_body.append('time', String(knowledge_detail_change_product_d_modal_onfinish_select_info.time));

    knowledge_detail_change_product_d_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: knowledge_detail_change_product_d_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setknowledge_detail_change_product_d_modal_open(false)

                    setreturn_data_knowledge_detail_change_product_d(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (knowledge_detail_change_product_d_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_change_product_d_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_change_product_d_modal_onfinish_select_log]);


    const [fetch_sort_shop_select_info, setfetch_sort_shop_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [fetch_sort_shop_select_log, setfetch_sort_shop_select_log] = useState({message: '', value: '', time: 0})
    const fetch_sort_shop = (e1: any) => {

        setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})


        setfetch_sort_shop_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

    const [table_date_s, settable_date_s] = useState([
        {
            'key': '1',
            "name": "健康保健",
            "label": "健康保健",
            "children": [
                {
                    'key': '2',
                    "name": "桶装",
                    "label": "桶装",
                    "children": [
                        {
                            'key': '3',
                            "name": "12",
                            "label": "12"
                        }
                    ]
                }

            ]
        }
    ])


    const [return_data_fetch_sort_shop, setreturn_data_fetch_sort_shop] = useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "2",
                "uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                "userid": null,
                "sort_name": "健康保健",
                "created": null,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999",
                "children": []
            },
            {
                "id": "3",
                "uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                "userid": null,
                "sort_name": "桶装",
                "created": null,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999",
                "children": [
                    {
                        "id": "4",
                        "uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
                        "userid": null,
                        "sort_name": "12",
                        "created": "1729152105",
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                        "country_code": "56888",
                        "region_parent_id": null,
                        "region_id": null,
                        "row_num": "999",
                        "children": []
                    }
                ]
            },
            {
                "id": "5",
                "uuid": "9a8dcd62-dc4c-415c-8b11-a3efd4494ebd",
                "userid": null,
                "sort_name": "11",
                "created": "1729152355",
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": null,
                "row_num": "999",
                "children": []
            }
        ]
    });

    const fetch_sort_shop_body = new FormData();


    fetch_sort_shop_body.append('id', fetch_sort_shop_select_info.value1);

    fetch_sort_shop_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_sort_shop_body.append('time', String(fetch_sort_shop_select_info.time));

    fetch_sort_shop_body.append('action', 'fetch_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/sort_shop/fetch/fetch_sort_shop.php', {


                method: 'POST',
                body: fetch_sort_shop_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_sort_shop(return_data);

                    //  setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (fetch_sort_shop_select_log.message !== '') {

            data_async();
            setfetch_sort_shop_select_log({message: '', value: '', time: 0})
        }
    }, [fetch_sort_shop_select_log]);


    const knowledge_detail_menu_onclick_menu = (e1: any) => {


        console.log(e1)

        setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})


        setfilter_spu_sort_uuid_select_info({value1: e1.key, value2: '', value3: '', time: data_time})


    }


    const onchange_cascader_d = (e1: any) => {


        console.log({e1: e1})

        setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})


        setfilter_spu_sort_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})


    }


    const [filter_spu_sort_uuid_select_info, setfilter_spu_sort_uuid_select_info] = useState({
        value1: '1',
        value2: '',
        value3: '',
        time: 0
    })

    const [filter_spu_sort_uuid_select_log, setfilter_spu_sort_uuid_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const filter_spu_sort_uuid = (e1: any) => {

        setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})


        setfilter_spu_sort_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_filter_spu_sort_uuid, setreturn_data_filter_spu_sort_uuid] = useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "3",
                "uuid": "100003",
                "name": "Dell XPS 13",
                "description": "高性能轻薄笔记本电脑，适合商务办公和娱乐",
                "category_id": "2",
                "brand_id": "3",
                "sort_shop_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                "status": "1",
                "status_type": "下架",
                "buy_it_now": "600",
                "image_card_img": "https://myupdat.leytcn.com/upload/1726199774_Untitled-3.jpg",
                "region_id": "6666",
                "created": "1",
                "node_value": null,
                "updated": "1732779731",
                "created_at": "2024-10-24 14:29:00",
                "updated_at": "2024-11-28 15:42:11",
                "country_code": "56888"
            },

        ]
    });

    const filter_spu_sort_uuid_body = new FormData();


    filter_spu_sort_uuid_body.append('sort_end_uuid', filter_spu_sort_uuid_select_info.value1);

    filter_spu_sort_uuid_body.append('userToken', String(Cookies.get('userToken_chattool')));

    filter_spu_sort_uuid_body.append('time', String(filter_spu_sort_uuid_select_info.time));

    filter_spu_sort_uuid_body.append('action', 'fetch_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/spu/filter/filter_spu_uuid.php', {


                method: 'POST',
                body: filter_spu_sort_uuid_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_filter_spu_sort_uuid(return_data);
                    // setfetch_spu_info_data_source(return_data);
                    //            setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/detail')


                    break


            }

        }


        if (filter_spu_sort_uuid_select_log.message !== '') {

            data_async();
            setfilter_spu_sort_uuid_select_log({message: '', value: '', time: 0})
        }
    }, [filter_spu_sort_uuid_select_log]);


    const cancel_filter_spu = () => {


        //    setfetch_spu_info_select_log({message:'1',value:'',time:data_time})

    }


    const naviget_ne = (url: any) => {

        setknowledge_detail_change_product_d_modal_oncancel();
        navigate('/admin/detail?product_uuid=' + url)
        //  setfetch_knowledge_knowledge_scene_select_log({message: 'dd', value: '', time: data_time})
        setfetch_knowledge_detail_select_log({message: 'dd', value: '', time: data_time})


    }


    const [knowledge_detail_sceneQuestion_edit_modal_open, setknowledge_detail_sceneQuestion_edit_modal_open] = useState(false)

    const [knowledge_detail_sceneQuestion_edit_select_info, setknowledge_detail_sceneQuestion_edit_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_sceneQuestion_edit_select_log, setknowledge_detail_sceneQuestion_edit_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_sceneQuestion_edit = (e1: any,e2:any) => {
        knowledge_detail_sceneQuestion_edit_modal_form.setFieldValue('sceneQuestion_name',e2)
        setknowledge_detail_sceneQuestion_edit_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_sceneQuestion_edit_modal_open(true);

        setknowledge_detail_sceneQuestion_edit_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_sceneQuestion_edit_modal_oncancel = () => {

        setknowledge_detail_sceneQuestion_edit_modal_open(false);
    }


    const [knowledge_detail_sceneQuestion_edit_modal_form] = Form.useForm();

    const knowledge_detail_sceneQuestion_edit_modal_initialValues = {}

    const [knowledge_detail_sceneQuestion_edit_modal_onfinish_select_log, setknowledge_detail_sceneQuestion_edit_modal_onfinish_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const [knowledge_detail_sceneQuestion_edit_modal_onfinish_select_info, setknowledge_detail_sceneQuestion_edit_modal_onfinish_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    });

    const knowledge_detail_sceneQuestion_edit_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setknowledge_detail_sceneQuestion_edit_modal_onfinish_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })
        setknowledge_detail_sceneQuestion_edit_modal_onfinish_select_info({
            value1: e1,
            value2: '',
            value3: '',
            time: data_time
        })
    }


    const [return_data_knowledge_detail_sceneQuestion_edit, setreturn_data_knowledge_detail_sceneQuestion_edit] = useState({});

    const knowledge_detail_sceneQuestion_edit_body = new FormData();
    knowledge_detail_sceneQuestion_edit_body.append('uuid', knowledge_detail_sceneQuestion_edit_select_info.value1);


    knowledge_detail_sceneQuestion_edit_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));

    knowledge_detail_sceneQuestion_edit_body.append('finish_data', JSON.stringify(knowledge_detail_sceneQuestion_edit_modal_onfinish_select_info.value1));

    knowledge_detail_sceneQuestion_edit_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_sceneQuestion_edit_body.append('time', String(knowledge_detail_sceneQuestion_edit_modal_onfinish_select_info.time));

    knowledge_detail_sceneQuestion_edit_body.append('action', 'add_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/question/update/update_question.php', {


                method: 'POST',
                body: knowledge_detail_sceneQuestion_edit_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setknowledge_detail_sceneQuestion_edit_modal_open(false)

                    setreturn_data_knowledge_detail_sceneQuestion_edit(return_data);

                    setfetch_knowledge_knowledge_scene_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if (knowledge_detail_sceneQuestion_edit_modal_onfinish_select_log.message !== '') {

            data_async();
            setknowledge_detail_sceneQuestion_edit_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_sceneQuestion_edit_modal_onfinish_select_log]);


    const [knowledge_detail_sceneQuestion_del_modal_open, setknowledge_detail_sceneQuestion_del_modal_open] = useState(false)

    const [knowledge_detail_sceneQuestion_del_select_info, setknowledge_detail_sceneQuestion_del_select_info] = useState({
        value1: '',
        value2: '',
        value3: '',
        time: 0
    })

    const [knowledge_detail_sceneQuestion_del_select_log, setknowledge_detail_sceneQuestion_del_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })
    const knowledge_detail_sceneQuestion_del = (e1: any) => {

        setknowledge_detail_sceneQuestion_del_select_log({message: 'click', value: '', time: data_time})

        setknowledge_detail_sceneQuestion_del_modal_open(true);

        setknowledge_detail_sceneQuestion_del_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setknowledge_detail_sceneQuestion_del_modal_oncancel = () => {

        setknowledge_detail_sceneQuestion_del_modal_open(false);
    }


    const [knowledge_detail_sceneQuestion_del_modal_next_button_select_log, setknowledge_detail_sceneQuestion_del_modal_next_button_select_log] = useState({
        message: '',
        value: '',
        time: 0
    })

    const knowledge_detail_sceneQuestion_del_modal_next_button = () => {

        let data_time = dayjs().unix();

        setknowledge_detail_sceneQuestion_del_modal_next_button_select_log({
            message: 'next_button',
            value: '',
            time: data_time
        })

    }


    const [return_data_knowledge_detail_sceneQuestion_del, setreturn_data_knowledge_detail_sceneQuestion_del] = useState({});

    const knowledge_detail_sceneQuestion_del_body = new FormData();

    knowledge_detail_sceneQuestion_del_body.append('uuid', knowledge_detail_sceneQuestion_del_select_info.value1);


    knowledge_detail_sceneQuestion_del_body.append('product_uuid', String(url_info_ldd.get('product_uuid')));


    knowledge_detail_sceneQuestion_del_body.append('userToken', String(Cookies.get('userToken_chattool')));

    knowledge_detail_sceneQuestion_del_body.append('time', String(knowledge_detail_sceneQuestion_del_modal_next_button_select_log.time));

    knowledge_detail_sceneQuestion_del_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/knowledge_detail/question/delete/delete_question.php', {


                method: 'POST',
                body: knowledge_detail_sceneQuestion_del_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setknowledge_detail_sceneQuestion_del_modal_open(false)

                    setreturn_data_knowledge_detail_sceneQuestion_del(return_data);
                    setfetch_knowledge_knowledge_scene_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if (knowledge_detail_sceneQuestion_del_modal_next_button_select_log.message !== '') {

            data_async();
            setknowledge_detail_sceneQuestion_del_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [knowledge_detail_sceneQuestion_del_modal_next_button_select_log]);


    return (<div className="admin-fill-page admin-detail-page">

        {/*<Breadcrumb items={[{title: '首页'}, {
            title: '知识库管理', onClick: () => {
                window.location.href = '/admin/knowledge_base'
            }
        }, {title: '知识库详情}]}/'>
*/}
        {/*

        <p></p>


        <MdRefresh  size={'1.5em'} onClick={fetch_knowledge_detail}>刷新</MdRefresh >
        <p></p>
*/}


        <Card>


            {url_info_ldd.get('product_uuid') !== null ? <div className="admin-detail-content-scroll">
                <div>

                    {return_data_fetch_knowledge_detail.message !== 2000 ? <Empty description="暂无知识库数据"/> :
                        <div style={{display: 'flex'}}>


                            <div style={{display: 'flex', width: '500px'}}>

                                <div style={{}}>
                                    <img
                                        style={{
                                            width: '100px',  // 增大图片宽度
                                            objectFit: 'cover',
                                            height: '100px', // 增大图片高度
                                            borderRadius: '4px',  // 可选：让图片有圆角
                                        }}
                                        src={return_data_fetch_knowledge_detail.info.spu.image_card_img}
                                        alt={return_data_fetch_knowledge_detail.info.spu.image_card_img} // 添加alt属性用于无障碍访问
                                    />
                                </div>


                                <div style={{marginLeft: 15, content: 'contents'}}>


                                    <label
                                        style={{fontSize: '15px'}}>{return_data_fetch_knowledge_detail.info.spu.name}</label>

                                    <br></br>
                                    <label style={{
                                        color: '#00000073',
                                        fontSize: '14px'
                                    }}>{return_data_fetch_knowledge_detail.info.spu.description}</label>
                                    <br></br>
                                    {/*   uuid：{return_data_fetch_knowledge_detail.info.spu.uuid}
                                                            <br></br>
                                                        */}

                                    uuid：{return_data_fetch_knowledge_detail.info.spu.uuid}
                                    <br></br>
                                    <label style={{
                                        color: '#ff5500',
                                        fontSize: '14px'
                                    }}>¥ {return_data_fetch_knowledge_detail.info.spu.buy_it_now}</label>


                                    {/*  <div>

                                    {dayjs.unix(return_data_fetch_knowledge_detail.info.spu.created).format('YYYY-MM-DD HH:mm:ss')}
                                </div>*/}
                                </div>

                            </div>
                            <div>

                                {/* 商品状态：    <Tag color={'red'}>{return_data_fetch_knowledge_detail.info.spu.status_type}</Tag>
*/}

                                {return_data_fetch_knowledge_detail.info.spu.status_type === '删除' ? <div>商品状态：<Tag
                                        color={'#f50'}>{return_data_fetch_knowledge_detail.info.spu.status_type}</Tag>
                                    </div> :
                                    <div></div>}

                                {return_data_fetch_knowledge_detail.info.spu.status_type === '下架' ? <div>商品状态：<Tag
                                        color={'#f50'}>{return_data_fetch_knowledge_detail.info.spu.status_type}</Tag>
                                    </div> :
                                    <div></div>}
                                {return_data_fetch_knowledge_detail.info.spu.status_type === '在售' ?
                                    <div>商品状态：<Tag
                                        color={'#87d068'}>{return_data_fetch_knowledge_detail.info.spu.status_type}</Tag>
                                    </div> : <div></div>}


                            </div>
                            <AiOutlineSwap size={'1.5em'}
                                           onClick={knowledge_detail_change_product_d}>更换商品</AiOutlineSwap>


                        </div>}

                    <Card>


                        <Form form={search_knowledge_detail_modal_form}
                              initialValues={search_knowledge_detail_modal_initialValues}
                              onFinish={search_knowledge_detail_modal_onfinish}>

                            <Form.Item label={'问题'} name={'scene_search'}>

                                <Input>

                                </Input>

                            </Form.Item>


                            <Form.Item label={'问法'} name={'scene_scene_question'}>

                                <Input>

                                </Input>

                            </Form.Item>

                            <Form.Item label={'回复内容'} name={'scene_scene_solution'}>

                                <Input>

                                </Input>

                            </Form.Item>


                            <Button htmlType={'submit'} type={'primary'}>搜索</Button>

                            <Button style={{marginLeft: 10}} onClick={cancal_filter_button}>重置</Button>
                        </Form>


                    </Card>


                    {/*      <Button onClick={fetch_knowledge_detail_tabs_one_info}>管理主级</Button>*/}
                    <p></p>
                    {/*  <Button onClick={knowledge_detail_tabs_two}>添加二级</Button>*/}

                    {/*  <Button onClick={fetch_knowledge_detail_tabs_two_info}>管理二级</Button>*/}

                    {filter_table !== '1' ? <div><Tabs tabBarStyle={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "8px",
                        height:45
                    }} tabBarExtraContent={
                        <Button type="link" onClick={fetch_knowledge_detail_tabs_one_info}>
                            添加 / 编辑分组
                        </Button>
                    } onEdit={onEdit_one_tab} onChange={onClick_tabs_one_switch} activeKey={tabs_one_activeKey}
                                                       items={return_data_fetch_knowledge_detail.info.detail.map((item: any) => ({
                                                           key: item.uuid, label: item.sort_name, children: <div>

                                                               <Button
                                                                   onClick={add_knowledge_scene}>添加场景</Button>
<p></p>
                                                               <Table

                                                                   scroll={{x: 'max-content'}}
                                                                   dataSource={return_data_fetch_knowledge_knowledge_scene.info.scene.map((item1) => ({
                                                                       key: item1.uuid,
                                                                       title: item1.title,
                                                                       sceneQuestion: item1.scene_question,
                                                                       sceneSolution: item1.scene_solution,
                                                                   }))}
                                                                   columns={[
                                                                       {
                                                                           key: 'name',
                                                                           dataIndex: 'title',
                                                                           title: '买家问题',
                                                                           width: 300,
                                                                           render: (title, record) => (
                                                                               <div style={{}}>
                                                                                   {/* 内容部分，占据剩余空*/}
                                                                                   <div
                                                                                       style={{width: '100%'}}>


                                                                                  <label style={{fontWeight:'bold'}}>  问题名称</label><label>{title}</label>



                                                                                       <div style={{display:'flex'}}>


                                                                                           <div>
                                                                                               <label>问法示例</label>




                                                                                               {/* <FaCogs
                                                                                                               onClick={() => knowledge_detail_scene_question_add(record.key)}
                                                                                                               style={{}}
                                                                                                           >
                                                                                                               管理示例
                                                                                                           </FaCogs >*/}


                                                                                           </div>


                                                                                           <div>
                                                                                               <FaPlus
                                                                                                   onClick={() => knowledge_detail_scene_question_add(record.key)}
                                                                                                   style={{}}
                                                                                               >
                                                                                                   添加
                                                                                               </FaPlus>
                                                                                               {record.sceneQuestion.map((item_qu) => (

                                                                                                   <div
                                                                                                       key={item_qu.uuid}>
                                                                                                       {item_qu.title}


                                                                                                       <EditOutlined
                                                                                                           style={{marginLeft: 10}}
                                                                                                           onClick={() => knowledge_detail_sceneQuestion_edit(item_qu.uuid,item_qu.title)}>编辑</EditOutlined>

                                                                                                       <DeleteOutlined
                                                                                                           style={{marginLeft: 10}}
                                                                                                           onClick={() => knowledge_detail_sceneQuestion_del(item_qu.uuid)}>删除</DeleteOutlined>

                                                                                                   </div>


                                                                                               ))}
                                                                                           </div>


                                                                                       </div>


                                                                                   </div>

                                                                                   {/* 按钮部分 */}


                                                                               </div>


                                                                           ),
                                                                       },
                                                                       {
                                                                           key: 'scene_solution',
                                                                           dataIndex: 'sceneSolution',
                                                                           title: '回复内容',
                                                                           width: 400,
                                                                           render: (sceneSolution, record) => (
                                                                               <Flex vertical>
                                                                                   <div
                                                                                       style={{


                                                                                       }}>

                                                                                       <div>
                                                                                           <FaPlus
                                                                                               onClick={() => knowledge_detail_solution_add(record.key)}>添加回答</FaPlus>


                                                                                       </div>
                                                                                       {sceneSolution.map((item_qu: any) => (

                                                                                           <div
                                                                                               style={{}}>

                                                                                              <label>{item_qu.title}</label>
                                                                                               <CopyOutlined
                                                                                                   style={{marginLeft: 10}}
                                                                                                   onClick={() => copy_clipbord(item_qu.title)}>复制</CopyOutlined>

                                                                                               <EditOutlined
                                                                                                   style={{marginLeft: 10}}
                                                                                                   onClick={() => knowledge_detail_scene_solution_edit(item_qu.uuid,item_qu.title)}>编辑</EditOutlined>

                                                                                               <DeleteOutlined
                                                                                                   style={{marginLeft: 10}}
                                                                                                   onClick={() => knowledge_detail_scene_solution_del(item_qu.uuid)}>删除</DeleteOutlined>


                                                                                           </div>

                                                                                       ))}
                                                                                   </div>



                                                                               </Flex>
                                                                           ),
                                                                       },

                                                                       {
                                                                           key: 'actions',
                                                                           title: '操作',


                                                                           render: (_, record) => (
                                                                               <div
                                                                                   style={{
                                                                                       display: 'flex',
                                                                                       gap: '8px'
                                                                                   }}>
                                                                                   <label
                                                                                       style={{
                                                                                           color: 'blue',
                                                                                           cursor: 'pointer'
                                                                                       }}
                                                                                       onClick={() => knowledge_detail_scene_edit_name(record.key, record.title)}
                                                                                   >
                                                                                       编辑
                                                                                   </label>
                                                                                   <label
                                                                                       style={{
                                                                                           color: 'red',
                                                                                           cursor: 'pointer'
                                                                                       }}
                                                                                       onClick={() => knowledge_detail_scene_del_item(record.key)}
                                                                                   >
                                                                                       删除
                                                                                   </label>
                                                                               </div>
                                                                           ),
                                                                       },
                                                                   ]}
                                                               />
                                                           {/*    {return_data_fetch_knowledge_detail.info.detail.length > 0 ?
                                                                   <div>


                                                                       <Tabs tabBarStyle={{
                                                                           backgroundColor: "#f5f5f5",
                                                                           borderRadius: "8px",
                                                                           height:45
                                                                       }} onChange={onClick_tabs_v} tabBarExtraContent={
                                                                           <Button type="link"
                                                                                   onClick={fetch_knowledge_detail_tabs_two_info}>
                                                                               添加 / 编辑分组
                                                                           </Button>
                                                                       } activeKey={tabs_two_activeKey}
                                                                             items={item.children.map((item3: any) => ({
                                                                                 key: item3.uuid,
                                                                                 label: <span>{item3.sort_name}</span>
                                                                             }))}/>


                                                                                             {tabs_one_activeKey}
<p></p>
                                  {tabs_two_activeKey}

                                                                       {item.children.length > 0 ? <div><Button
                                                                           onClick={add_knowledge_scene}>添加场景</Button>

                                                                           <div className="custom-table">


                                                                               <Table

                                                                                   scroll={{x: 'max-content'}}
                                                                                   dataSource={return_data_fetch_knowledge_knowledge_scene.info.scene.map((item1) => ({
                                                                                       key: item1.uuid,
                                                                                       title: item1.title,
                                                                                       sceneQuestion: item1.scene_question,
                                                                                       sceneSolution: item1.scene_solution,
                                                                                   }))}
                                                                                   columns={[
                                                                                       {
                                                                                           key: 'name',
                                                                                           dataIndex: 'title',
                                                                                           title: '买家问题',
                                                                                           width: 300,
                                                                                           render: (title, record) => (
                                                                                               <div style={{}}>
                                                                                                    内容部分，占据剩余空
                                                                                                   <div
                                                                                                       style={{width: '100%'}}>


                                                                                                       <p>问题名称<label>{title}</label>
                                                                                                       </p>


                                                                                                       <div style={{}}>


                                                                                                           <div>
                                                                                                               <label>问题示例</label>


                                                                                                               <FaPlus
                                                                                                                   onClick={() => knowledge_detail_scene_question_add(record.key)}
                                                                                                                   style={{}}
                                                                                                               >
                                                                                                                   添加
                                                                                                               </FaPlus>

                                                                                                                <FaCogs
                                                                                                               onClick={() => knowledge_detail_scene_question_add(record.key)}
                                                                                                               style={{}}
                                                                                                           >
                                                                                                               管理示例
                                                                                                           </FaCogs >


                                                                                                           </div>


                                                                                                           <div>
                                                                                                               {record.sceneQuestion.map((item_qu) => (

                                                                                                                   <div
                                                                                                                       key={item_qu.uuid}>
                                                                                                                       {item_qu.title}


                                                                                                                       <EditOutlined
                                                                                                                           style={{marginLeft: 10}}
                                                                                                                           onClick={() => knowledge_detail_sceneQuestion_edit(item_qu.uuid)}>编辑</EditOutlined>

                                                                                                                       <DeleteOutlined
                                                                                                                           style={{marginLeft: 10}}
                                                                                                                           onClick={() => knowledge_detail_sceneQuestion_del(item_qu.uuid)}>删除</DeleteOutlined>

                                                                                                                   </div>


                                                                                                               ))}
                                                                                                           </div>


                                                                                                       </div>


                                                                                                   </div>

                                                                                                    按钮部分


                                                                                               </div>


                                                                                           ),
                                                                                       },
                                                                                       {
                                                                                           key: 'scene_solution',
                                                                                           dataIndex: 'sceneSolution',
                                                                                           title: '回复内容',
                                                                                           width: 400,
                                                                                           render: (sceneSolution, record) => (
                                                                                               <Flex vertical>
                                                                                                   <div
                                                                                                       style={{
                                                                                                           flexDirection: 'column',
                                                                                                           flexGrow: 1
                                                                                                       }}>
                                                                                                       {sceneSolution.map((item_qu: any) => (

                                                                                                           <div
                                                                                                               style={{height: 50}}>

                                                                                                               {item_qu.title}
                                                                                                               <CopyOutlined
                                                                                                                   style={{marginLeft: 10}}
                                                                                                                   onClick={() => copy_clipbord(item_qu.title)}>复制</CopyOutlined>

                                                                                                               <EditOutlined
                                                                                                                   style={{marginLeft: 10}}
                                                                                                                   onClick={() => knowledge_detail_scene_solution_edit(item_qu.uuid)}>编辑</EditOutlined>

                                                                                                               <DeleteOutlined
                                                                                                                   style={{marginLeft: 10}}
                                                                                                                   onClick={() => knowledge_detail_scene_solution_del(item_qu.uuid)}>删除</DeleteOutlined>


                                                                                                           </div>

                                                                                                       ))}
                                                                                                   </div>


                                                                                                   <div>
                                                                                                       <FaPlus
                                                                                                           onClick={() => knowledge_detail_solution_add(record.key)}>添加回答</FaPlus>


                                                                                                   </div>
                                                                                               </Flex>
                                                                                           ),
                                                                                       },

                                                                                       {
                                                                                           key: 'actions',
                                                                                           title: '操作',


                                                                                           render: (_, record) => (
                                                                                               <div
                                                                                                   style={{
                                                                                                       display: 'flex',
                                                                                                       gap: '8px'
                                                                                                   }}>
                                                                                                   <label
                                                                                                       style={{
                                                                                                           color: 'blue',
                                                                                                           cursor: 'pointer'
                                                                                                       }}
                                                                                                       onClick={() => knowledge_detail_scene_edit_name(record.key)}
                                                                                                   >
                                                                                                       编辑
                                                                                                   </label>
                                                                                                   <label
                                                                                                       style={{
                                                                                                           color: 'red',
                                                                                                           cursor: 'pointer'
                                                                                                       }}
                                                                                                       onClick={() => knowledge_detail_scene_del_item(record.key)}
                                                                                                   >
                                                                                                       删除
                                                                                                   </label>
                                                                                               </div>
                                                                                           ),
                                                                                       },
                                                                                   ]}
                                                                               /></div>
                                                                       </div> : <div></div>}


                                                                   </div> : <div></div>}*/}


                                                           </div>
                                                       }))}/>

                    </div> : <div>
                        <Anchor
                            items={return_data_fetch_knowledge_knowledge_scene.info.scene.map(item1 => ({
                                key: item1.uuid,
                                href: '#' + item1.uuid,
                                title: item1.title
                            }))}
                            style={{
                                position: 'fixed',
                                top: '90px',
                                right: '20px',
                                width: '200px',
                            }}/>
                        <div>
                            <div className="custom-table">


                                <Table
                                    dataSource={return_data_fetch_knowledge_knowledge_scene.info.scene.map((item1) => ({
                                        key: item1.uuid,
                                        title: item1.title,
                                        sceneQuestion: item1.scene_question,
                                        sceneSolution: item1.scene_solution,
                                        tab1_info_sort_name: item1.tab1_info.sort_name,
                                        tab2_info_sort_name: item1.tab2_info.sort_name
                                    }))}
                                    columns={[
                                        {
                                            key: 'name',
                                            dataIndex: 'title',
                                            title: '买家问题',
                                            width: 300,
                                            render: (title, record) => (
                                                <div id={record.key} style={{}}>
                                                    {/* 内容部分，占据剩余空*/}
                                                    <div style={{width: '100%'}}>


                                                        <p>问题名称<label>{title}</label></p>


                                                        <div style={{}}>

                                                            <label>分类信息：{record.tab1_info_sort_name}{/*{'->'}{record.tab2_info_sort_name}*/}</label>

                                                            <p></p>
                                                            <div>
                                                                <label>问题示例</label>


                                                                <FaPlus
                                                                    onClick={() => knowledge_detail_scene_question_add(record.key)}
                                                                    style={{}}
                                                                >
                                                                    添加
                                                                </FaPlus>

                                                                {/* <FaCogs
                                                                                                               onClick={() => knowledge_detail_scene_question_add(record.key)}
                                                                                                               style={{}}
                                                                                                           >
                                                                                                               管理示例
                                                                                                           </FaCogs >*/}


                                                            </div>


                                                            <div>
                                                                {record.sceneQuestion.map((item_qu) => (

                                                                    <div
                                                                        key={item_qu.uuid}>
                                                                        {item_qu.title}


                                                                        <EditOutlined
                                                                            style={{marginLeft: 10}}
                                                                            onClick={() => knowledge_detail_sceneQuestion_edit(item_qu.uuid,item_qu.title)}>编辑</EditOutlined>

                                                                        <DeleteOutlined
                                                                            style={{marginLeft: 10}}
                                                                            onClick={() => knowledge_detail_sceneQuestion_del(item_qu.uuid)}>删除</DeleteOutlined>

                                                                    </div>


                                                                ))}
                                                            </div>


                                                        </div>


                                                    </div>

                                                    {/* 按钮部分 */}


                                                </div>


                                            ),
                                        },
                                        {
                                            key: 'scene_solution',
                                            dataIndex: 'sceneSolution',
                                            title: '回复内容',
                                            width: 400,
                                            render: (sceneSolution, record) => (
                                                <Flex vertical>
                                                    <div style={{flexDirection: 'column', flexGrow: 1}}>
                                                        {sceneSolution.map((item_qu: any) => (

                                                            <div style={{display:'flex'}}>

                                                               <label> {item_qu.title}</label>
                                                                <CopyOutlined style={{marginLeft: 10}}
                                                                              onClick={() => copy_clipbord(item_qu.title)}>复制</CopyOutlined>

                                                                <EditOutlined style={{marginLeft: 10}}
                                                                              onClick={() => knowledge_detail_scene_solution_edit(item_qu.uuid,item_qu.title)}>编辑</EditOutlined>

                                                                <DeleteOutlined style={{marginLeft: 10}}
                                                                                onClick={() => knowledge_detail_scene_solution_del(item_qu.uuid)}>删除</DeleteOutlined>


                                                            </div>

                                                        ))}
                                                    </div>


                                                    <div>
                                                        <FaPlus
                                                            onClick={() => knowledge_detail_solution_add(record.key)}>添加回答</FaPlus>


                                                    </div>
                                                </Flex>
                                            ),
                                        },

                                        {
                                            key: 'actions',
                                            title: '操作',


                                            render: (_, record) => (
                                                <div style={{display: 'flex', gap: '8px'}}>
                                                    <label
                                                        style={{color: 'blue', cursor: 'pointer'}}
                                                        onClick={() => knowledge_detail_scene_edit_name(record.key, record.title)}
                                                    >
                                                        编辑
                                                    </label>
                                                    <label
                                                        style={{color: 'red', cursor: 'pointer'}}
                                                        onClick={() => knowledge_detail_scene_del_item(record.key)}
                                                    >
                                                        删除
                                                    </label>
                                                </div>
                                            ),
                                        },
                                    ]}
                                />

                            </div>
                        </div>
                    </div>}


                </div>
            </div> : <div className="admin-detail-product-picker">


                <div className="admin-detail-picker-layout">
                    {/* 固定左侧 Menu */}


                    <Menu className="admin-detail-picker-menu"
                        style={{
                            overflow: 'auto',
                            width: 150, // 固定宽度

                        }}
                        mode="inline"
                        defaultSelectedKeys={['1']}
                        onClick={knowledge_detail_menu_onclick_menu}
                        items={[
                            {key: '1', label: '全部商品'},
                            {
                                key: '2',
                                label: '店铺分类',
                                children: return_data_fetch_sort_shop.message !== 2000 ? [] : return_data_fetch_sort_shop.info.map(item1 => ({
                                    key: item1.uuid,
                                    label: item1.sort_name,
                                    children: item1.children.length > 0 ? item1.children.map(item1_children_d => ({
                                        key: item1_children_d.uuid,
                                        label: item1_children_d.sort_name,
                                    })) : null,
                                })),
                            }, {key: '3', label: '未分类'}
                        ]}
                    />


                    {/* 右侧内容部分 */}
                    <div className="admin-detail-picker-content"
                        style={{
                            flex: 1, // 填充剩余空间
                            padding: 10, // 给内容增加内边距
                        }}
                    >


                        {return_data_filter_spu_sort_uuid.message !== 2000 ? <Empty description="暂无商品数据"/> :
                            <div> {return_data_filter_spu_sort_uuid.info.map(item1 => (
                                <div key={item1.uuid}>
                                    <div style={{display: 'flex', marginBottom: 10}}>
                                        <img
                                            style={{
                                                width: '100px', // 固定图片宽度
                                                height: '100px', // 固定图片高度
                                                objectFit: 'cover', // 保持图片比例裁剪
                                                borderRadius: '4px', // 添加圆角
                                            }}
                                            src={item1.image_card_img}
                                            alt={item1.image_card_img} // 无障碍支
                                        />
                                        <div style={{marginLeft: 15}}>
                                            <div>{item1.name}</div>
                                            <p>uuid：{item1.uuid}</p>
                                            <Button onClick={() => naviget_ne(item1.uuid)}>选择</Button>
                                        </div>
                                    </div>
                                    <Divider/>
                                </div>))}</div>
                        }


                    </div>
                </div>

                {/*
                请输入内容


               <Button onClick={knowledge_detail_change_product_d}>选择商品</Button>

                <Form form={knowledge_search_product_uuid_modal_form}
                      initialValues={knowledge_search_product_uuid_modal_initialValues}
                      onFinish={knowledge_search_product_uuid_modal_onfinish}>

                    <label>product_uuid</label>

                    <Form.Item name={'product_uuid'} rules={[{message: '必填项', required: true}]}>

                        <Input>


                        </Input>


                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>

                </Form>

                <p></p>*/}

            </div>}


        </Card>


        <Modal open={knowledge_detail_sceneQuestion_del_modal_open}
               onCancel={setknowledge_detail_sceneQuestion_del_modal_oncancel} footer={null} title={'标题内容'}>


            <Button onClick={knowledge_detail_sceneQuestion_del_modal_next_button}>

                确认删除
            </Button>


            <Button style={{marginLeft: 10}} onClick={setknowledge_detail_sceneQuestion_del_modal_oncancel}>

                取消
            </Button>


        </Modal>


        <Modal open={knowledge_detail_sceneQuestion_edit_modal_open}
               onCancel={setknowledge_detail_sceneQuestion_edit_modal_oncancel} footer={null} title={'修改问题示例'}>


            <Form form={knowledge_detail_sceneQuestion_edit_modal_form}
                  initialValues={knowledge_detail_sceneQuestion_edit_modal_initialValues}
                  onFinish={knowledge_detail_sceneQuestion_edit_modal_onfinish}>



                <Form.Item name={'sceneQuestion_name'} rules={[{message: '必填项', required: true}]}>

                    <Input placeholder={'问题'}>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}}
                        onClick={setknowledge_detail_sceneQuestion_edit_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={knowledge_detail_scene_solution_edit_modal_open}
               onCancel={setknowledge_detail_scene_solution_edit_modal_oncancel} footer={null} title={'修改回复话术'}>


            <Form form={knowledge_detail_scene_solution_edit_modal_form}
                  initialValues={knowledge_detail_scene_solution_edit_modal_initialValues}
                  onFinish={knowledge_detail_scene_solution_edit_modal_onfinish}>



                <Form.Item name={'scene_solution_name'} rules={[{message: '必填项', required: true}]}>

                    <TextArea style={{height: 200}} placeholder={'回复话术'}>


                    </TextArea>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}}
                        onClick={setknowledge_detail_scene_solution_edit_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Drawer open={fetch_knowledge_detail_tabs_one_info_modal_open}
                onClose={setfetch_knowledge_detail_tabs_one_info_modal_oncancel} footer={null} title={'管理主级'}>


            {/*    <Button onClick={knowledge_detail_tabs_one}>添加</Button>*/}

            {return_data_fetch_knowledge_detail_tabs_one_info.message !== 2000 ? <div>


            </div> : <div>
                <Form form={knowledge_detail_tabs_one_modal_form}
                      initialValues={knowledge_detail_tabs_one_modal_initialValues}
                      onFinish={knowledge_detail_tabs_one_modal_onfinish}>


                    <label style={{fontWeight: 'bold'}}>添加分组</label>
                    <p></p>
                    <label></label>

                    <div style={{display: 'flex'}}>


                        <Form.Item style={{flexGrow: 1}} name={'tab_name'}
                                   rules={[{message: '必填项', required: true}]}>

                            <Input placeholder={'分组'}>


                            </Input>


                        </Form.Item>


                        <Button style={{marginLeft: 5}} htmlType={'submit'} type={'primary'}>提交</Button>
                        {/* <Button style={{marginLeft: 10}} onClick={setknowledge_detail_tabs_one_modal_oncancel}>取消</Button>
*/}


                    </div>
                </Form>

                <Divider/>

                <label style={{fontWeight: 'bold'}}>管理编辑分组</label>

                <p></p>
                {return_data_fetch_knowledge_detail_tabs_one_info.info.map(item1 => (<div style={{}}>


                    <Card style={{width:'100%'}}>

                        <div style={{display: 'flex', justifyContent: 'space-between'}}>




                    <label>{item1.sort_name}</label>
                    <div style={{marginLeft: 10,justifyContent:'center'}}>


                        <EditOutlined onClick={() => tabs_one_rename(item1.uuid,item1.sort_name)}>重命</EditOutlined>

                        <DeleteOutlined style={{marginLeft: 10}}
                                        onClick={() => tabs_one_del(item1.uuid)}>删除</DeleteOutlined>


                     {/*   <Button>排序</Button>*/}
                    </div>
                        </div>
                    </Card>
                </div>))
                }</div>}


        </Drawer>


        <Drawer width={500} open={knowledge_detail_change_product_d_modal_open}
                onClose={setknowledge_detail_change_product_d_modal_oncancel} footer={null} title={'选择商品'}>


            <div style={{display: 'flex',}}>
                {/* 固定左侧 Menu */}


                <Menu
                    style={{
                        overflow: 'auto',
                        height: '100vh',
                        position: 'fixed',
                        width: 150, // 固定宽度

                    }}
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    onClick={knowledge_detail_menu_onclick_menu}
                    items={[
                        {key: '1', label: '全部商品'},
                        {
                            key: '2',
                            label: '店铺分类',
                            children: return_data_fetch_sort_shop.message !== 2000 ? [] : return_data_fetch_sort_shop.info.map(item1 => ({
                                key: item1.uuid,
                                label: item1.sort_name,
                                children: item1.children.length > 0 ? item1.children.map(item1_children_d => ({
                                    key: item1_children_d.uuid,
                                    label: item1_children_d.sort_name,
                                })) : null,
                            })),
                        }, {key: '3', label: '未分类'}
                    ]}
                />


                {/* 右侧内容部分 */}
                <div
                    style={{
                        marginLeft: 150,
                        flex: 1, // 填充剩余空间
                        overflowY: 'auto', // 添加滚动
                        padding: 10, // 给内容增加内边距
                    }}
                >

                    {return_data_filter_spu_sort_uuid.info.map(item1 => (
                        <div key={item1.uuid}>
                            <div style={{display: 'flex', marginBottom: 10}}>
                                <img
                                    style={{
                                        width: '100px', // 固定图片宽度
                                        height: '100px', // 固定图片高度
                                        objectFit: 'cover', // 保持图片比例裁剪
                                        borderRadius: '4px', // 添加圆角
                                    }}
                                    src={item1.image_card_img}
                                    alt={item1.image_card_img} // 无障碍支
                                />
                                <div style={{marginLeft: 15}}>
                                    <div>{item1.name}</div>
                                    <p>uuid：{item1.uuid}</p>
                                    <Button onClick={() => naviget_ne(item1.uuid)}>选择</Button>
                                </div>
                            </div>
                            <Divider/>
                        </div>))}


                </div>
            </div>


            {/*       <Form form={knowledge_detail_change_product_d_modal_form} initialValues={knowledge_detail_change_product_d_modal_initialValues} onFinish={knowledge_detail_change_product_d_modal_onfinish}>

                <label>value1</label>

                <Form.Item name={'input_value1'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>value2</label>

                <Form.Item name={'input_value2'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setknowledge_detail_change_product_d_modal_oncancel}>取消</Button>

            </Form>*/}


        </Drawer>


        <Drawer open={fetch_knowledge_detail_tabs_two_info_modal_open}
                onClose={setfetch_knowledge_detail_tabs_two_info_modal_oncancel} footer={null} title={'管理二级'}>


            {/*   <Button onClick={knowledge_detail_tabs_two}>添加二级</Button>
*/}
            {return_data_fetch_knowledge_detail_tabs_two_info.message !== 2000 ? <div>


            </div> : <div>

                <Form form={knowledge_detail_tabs_two_modal_form}
                      initialValues={knowledge_detail_tabs_two_modal_initialValues}
                      onFinish={knowledge_detail_tabs_two_modal_onfinish}>

                    <label>标签</label>

                    <div style={{display: 'flex'}}>

                        <Form.Item style={{flexGrow: 1}} name={'tab_name'}
                                   rules={[{message: '必填项', required: true}]}>

                            <Input>


                            </Input>


                        </Form.Item>


                        <Button style={{marginLeft: 5}} htmlType={'submit'} type={'primary'}>提交</Button>
                        {/*      <Button style={{marginLeft: 10}} onClick={setknowledge_detail_tabs_two_modal_oncancel}>取消</Button>
*/}


                    </div>
                </Form>


                {return_data_fetch_knowledge_detail_tabs_two_info.info.map(item1 => (<div>

                    主名：{item1.sort_name}
                    <EditOutlined onClick={() => tabs_two_rename(item1.uuid)}>重命</EditOutlined>

                    <DeleteOutlined onClick={() => tabs_two_del(item1.uuid)}>删除</DeleteOutlined>
                </div>))
                }</div>}


        </Drawer>


        <Modal open={knowledge_detail_scene_solution_del_modal_open}
               onCancel={setknowledge_detail_scene_solution_del_modal_oncancel} footer={null} title={'是否确认删除？'}>


            <Button onClick={knowledge_detail_scene_solution_del_modal_next_button}>

                确认删除
            </Button>


            <Button style={{marginLeft: 10}} onClick={setknowledge_detail_scene_solution_del_modal_oncancel}>

                取消
            </Button>


        </Modal>


        <Modal open={knowledge_detail_scene_del_item_modal_open}
               onCancel={setknowledge_detail_scene_del_item_modal_oncancel} footer={null} title={'是否确认删除？'}>


            <Button onClick={knowledge_detail_scene_del_item_modal_next_button}>

                确认删除
            </Button>


            <Button style={{marginLeft: 10}} onClick={setknowledge_detail_scene_del_item_modal_oncancel}>

                取消
            </Button>


        </Modal>


        <Modal open={knowledge_detail_scene_edit_name_modal_open}
               onCancel={setknowledge_detail_scene_edit_name_modal_oncancel} footer={null} title={'修改场景名称'}>


            <Form form={knowledge_detail_scene_edit_name_modal_form}
                  initialValues={knowledge_detail_scene_edit_name_modal_initialValues}
                  onFinish={knowledge_detail_scene_edit_name_modal_onfinish}>



                <Form.Item name={'scene_name'} rules={[{message: '必填项', required: true}]}>

                    <Input placeholder={'场景名称'}>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}}
                        onClick={setknowledge_detail_scene_edit_name_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={tabs_one_del_modal_open} onCancel={settabs_one_del_modal_oncancel} footer={null}
               title={'是否确认删除？'}>


            <Button onClick={tabs_one_del_modal_next_button}>

                确认删除
            </Button>


            <Button style={{marginLeft: 10}} onClick={settabs_one_del_modal_oncancel}>

                取消
            </Button>


        </Modal>


        <Modal open={tabs_two_del_modal_open} onCancel={settabs_two_del_modal_oncancel} footer={null}
               title={'是否确认删除？'}>


            <Button onClick={tabs_two_del_modal_next_button}>

                确认删除
            </Button>


            <Button style={{marginLeft: 10}} onClick={settabs_two_del_modal_oncancel}>

                取消
            </Button>


        </Modal>


        <Modal open={tabs_two_rename_modal_open} onCancel={settabs_two_rename_modal_oncancel} footer={null}
               title={'重命'}>


            <Form form={tabs_two_rename_modal_form} initialValues={tabs_two_rename_modal_initialValues}
                  onFinish={tabs_two_rename_modal_onfinish}>

                <label>value1</label>

                <Form.Item name={'tabs_two_rename'} rules={[{message: '必填项', required: true}]}>

                    <Input>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}} onClick={settabs_two_rename_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={tabs_one_rename_modal_open} onCancel={settabs_one_rename_modal_oncancel} footer={null}
               title={'重命'}>


            <Form form={tabs_one_rename_modal_form} initialValues={tabs_one_rename_modal_initialValues}
                  onFinish={tabs_one_rename_modal_onfinish}>

                {/*<label>名字</label>*/}

                <Form.Item name={'tabs_one_rename'} rules={[{message: '必填项', required: true}]}>

                    <Input placeholder={'分组'}>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}} onClick={settabs_one_rename_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={knowledge_detail_tabs_two_modal_open} onCancel={setknowledge_detail_tabs_two_modal_oncancel}
               footer={null} title={'添加二级标签'}>


            <Form form={knowledge_detail_tabs_two_modal_form}
                  initialValues={knowledge_detail_tabs_two_modal_initialValues}
                  onFinish={knowledge_detail_tabs_two_modal_onfinish}>

                <label>标签</label>

                <Form.Item name={'tab_name'} rules={[{message: '必填项', required: true}]}>

                    <Input>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}} onClick={setknowledge_detail_tabs_two_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={knowledge_detail_tabs_one_modal_open} onCancel={setknowledge_detail_tabs_one_modal_oncancel}
               footer={null} title={'添加一级标'}>


            <Form form={knowledge_detail_tabs_one_modal_form}
                  initialValues={knowledge_detail_tabs_one_modal_initialValues}
                  onFinish={knowledge_detail_tabs_one_modal_onfinish}>

                <label>标签</label>

                <Form.Item name={'tab_name'} rules={[{message: '必填项', required: true}]}>

                    <Input>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}} onClick={setknowledge_detail_tabs_one_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={knowledge_detail_solution_add_modal_open}
               onCancel={setknowledge_detail_solution_add_modal_oncancel} footer={null} title={'添加回答'}>


            <Form form={knowledge_detail_solution_add_modal_form}
                  initialValues={knowledge_detail_solution_add_modal_initialValues}
                  onFinish={knowledge_detail_solution_add_modal_onfinish}>



                <Form.Item name={'solution_message'} rules={[{message: '必填项', required: true}]}>

                    <Input.TextArea style={{height: 200}} placeholder={'回答内容'}>


                    </Input.TextArea>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}} onClick={setknowledge_detail_solution_add_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <Modal open={knowledge_detail_scene_question_add_modal_open}
               onCancel={setknowledge_detail_scene_question_add_modal_oncancel} footer={null} title={'添加示例语句'}>


            <Form form={knowledge_detail_scene_question_add_modal_form}
                  initialValues={knowledge_detail_scene_question_add_modal_initialValues}
                  onFinish={knowledge_detail_scene_question_add_modal_onfinish}>



                <Form.Item name={'question_title'} rules={[{message: '必填项', required: true}]}>

                    <Input placeholder={'示例语句'}>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}}
                        onClick={setknowledge_detail_scene_question_add_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


        <FloatButton.Group className="admin-float-actions">
            <FloatButton icon={<ReloadOutlined/>} tooltip="刷新知识库" onClick={fetch_knowledge_detail}/>
        </FloatButton.Group>

        <Modal open={add_knowledge_scene_modal_open} onCancel={setadd_knowledge_scene_modal_oncancel} footer={null}
               title={'添加场景'}>


            <Form form={add_knowledge_scene_modal_form} initialValues={add_knowledge_scene_modal_initialValues}
                  onFinish={add_knowledge_scene_modal_onfinish}>



                <Form.Item name={'scene_title'} rules={[{message: '必填项', required: true}]} >

                    <Input placeholder={'场景标题'}>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft: 10}} onClick={setadd_knowledge_scene_modal_oncancel}>取消</Button>

            </Form>


        </Modal>


    </div>)


}

export default Knowledge_detail
